module.exports = __webpack_public_path__ + "static/media/palette-top.fccb053b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SkwizColors/palette-top.gif
// module id = ./src/assets/SkwizColors/palette-top.gif
// module chunks = 0